<template>
  <div id="appBody" class="relative flex flex-col min-h-screen">
    <NotificationsHub />
    <ConfirmDialog></ConfirmDialog>
    <RouterView name="navbar"></RouterView>
    <!-- <div class="absolute top-0 start-0 w-full h-screen bg-teal-100"></div> -->
    <TopDrawer>
      <component :is="topbarContent[globalStore.topbarState]"></component>
    </TopDrawer>
    <main id="main" class="flex-grow">
      <RouterView />
    </main>
    <!-- <StartDrawer>
      <MobileMenuView />
    </StartDrawer> -->
    <EndDrawer>
      <SettingsView></SettingsView>
    </EndDrawer>

    <SoarFooter class="mt-4"></SoarFooter>
    <WebsiteCookieBanner v-if="!cookieBanner.hasAccepted.value" />
    <HighlightTracker></HighlightTracker>
    <CustomerpulseTrigger v-if="showSurveyButton" />
  </div>
</template>

<script setup>
import CustomerpulseTrigger from '@/components/CustomerpulseTrigger/index.vue'
import HighlightTracker from '@/components/HighlightTracker/index.vue'
import NotificationsHub from '@/components/NotificationsHub.vue'
import ConfirmDialog from '@/components/Ui/Confirm/index.vue'
import EndDrawer from '@/components/Ui/Drawer/EndDrawer.vue'
import TopDrawer from '@/components/Ui/Drawer/TopDrawer.vue'
import SoarFooter from '@/components/Ui/footer/index.vue'
import useCookieBanner from '@/composables/useCookieBanner'
import QuicksearchView from '@/quick-search/index.vue'
import MostvisitedGrid from '@/views/most-visited/index.vue'
import SettingsView from '@/views/settings/index.vue'
import WebsiteCookieBanner from '@/views/website-cookie/index.vue'
import { useCookies } from '@vueuse/integrations/useCookies'
import { computed, onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { useGlobalStore } from './stores/global'
import { useThemeStore } from './stores/theme'

const i18n = useI18n()
const cookieBanner = useCookieBanner()
const route = useRoute()

const themeStore = useThemeStore()
const globalStore = useGlobalStore()

const cookies = useCookies(['locale'])
const locale = cookies.get('i18n_redirected') || 'en'
i18n.locale.value = locale

const html = document.querySelector('html')
html.setAttribute('lang', locale)
html.setAttribute('dir', locale == 'ar' ? 'rtl' : 'ltr')

if (localStorage && localStorage.theme) {
  const themeStorage = JSON.parse(localStorage.theme)

  themeStore.selectTheme(themeStorage.currentTheme)
}

document.body.classList.add(themeStore.currentScheme)

onMounted(async () => {
  globalStore.$patch((state) => {
    state.topbarState = false
    state.endbarState = false
  })

  await globalStore.fetchClientConfig()
  await globalStore.fetchEnvConfig()

  document.body.style.overflow = cookieBanner.hasAccepted.value ? 'inherit' : 'hidden'
})

const topbarContent = computed(() => {
  if (globalStore.topbarState === false) return

  return {
    search: QuicksearchView,
    'most-visited': MostvisitedGrid
  }
})

watch(
  () => cookieBanner.hasAccepted.value,
  (newValue) => {
    document.body.style.overflow = newValue ? 'inherit' : 'hidden'
  }
)

const showSurveyButton = computed(() => {
  return [
    'home',
    'RegisterIndividuals',
    'forgetPassword',
    'EstablishmentChangeUsername',
    'RegisterEstablishments',
    'RegisterTypingCenters',
    'TypingcentersChangeUsername',
    'forgot-password'
  ].includes(route.name)
})
</script>

<style lang="scss" scoped></style>
